import type { ChatMessage } from '@teo/widget-shared';
import { sortMessagesByDate } from '@teo/widget-shared';

/** Client-only typing row — mirrors legacy `source_id: 99`. */
export const TYPING_PLACEHOLDER_MESSAGE_ID = 'teo-typing-placeholder';

export function isTypingPlaceholderMessage(message: ChatMessage): boolean {
  return (
    message.isTypingPlaceholder === true ||
    message.id === TYPING_PLACEHOLDER_MESSAGE_ID
  );
}

export function createTypingPlaceholderMessage(): ChatMessage {
  return {
    id: TYPING_PLACEHOLDER_MESSAGE_ID,
    role: 'bot',
    text: '',
    createdAt: new Date().toISOString(),
    isTypingPlaceholder: true,
  };
}

export function stripTypingPlaceholder(messages: ChatMessage[]): ChatMessage[] {
  return messages.filter((message) => !isTypingPlaceholderMessage(message));
}

export function withTypingPlaceholder(messages: ChatMessage[]): ChatMessage[] {
  const base = stripTypingPlaceholder(messages);
  return sortMessagesByDate([...base, createTypingPlaceholderMessage()]);
}
